import { amountToDisplayValue, Color, Text } from '@billy/design-system'
import { Badge, Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { useBalanceLabels } from '@features/balanceLedger'

import type { LedgerEntryColumnDef } from '../../../../../../hooks/useLedgerEntriesTableColumns'
import * as Styled from './styles'

interface OpeningBalanceGroupHeaderProps {
  columns: LedgerEntryColumnDef[]
  count: number
  totalBalance: number
}

export const OpeningBalanceGroupHeader = ({
  columns,
  count,
  totalBalance,
}: OpeningBalanceGroupHeaderProps): ReactElement => {
  const { bt } = useBalanceLabels()
  const amountColor = totalBalance < 0 ? Color.Red700 : undefined
  const showCountBadge = count > 0
  const showAmount = count === 0
  const label = bt('detail_view.opening_balance.label')
  const balanceColumn = columns.at(-1)
  const labelColSpan = columns.length - 1

  return (
    <Table.Row data-opening-balance-header highlighted>
      <Table.Cell colSpan={labelColSpan}>
        <Styled.LabelWrapper>
          <Text weight="semiBold" nowrap>
            {label}
          </Text>
          {showCountBadge && <Badge color="neutral" count={count} mode="primary" size="medium" />}
        </Styled.LabelWrapper>
      </Table.Cell>
      <Table.Cell align={balanceColumn?.align}>
        {showAmount && (
          <Styled.AmountWrapper>
            <Text color={amountColor}>{amountToDisplayValue(totalBalance)}</Text>
          </Styled.AmountWrapper>
        )}
      </Table.Cell>
    </Table.Row>
  )
}
